import BaseRequest from './base/BaseRequest';

export default class InsuranceRequest extends BaseRequest {

  getInsuranceFund() {
    const url = '/insurance';
    return this.get(url);
  }
}
